import React, {useEffect, useState} from 'react';
import TextInput from "../../../ui_components/TextInput/TextInput";
import PersonIcon from '@material-ui/icons/Person';
import LastNameInputProperties from "./LastNameInputProperties";
import {useI18nContext} from "../../../contexts/I18nContext";

const LastNameInput: React.FC<LastNameInputProperties> = ({
                                                                  value,
                                                                  placeholder,
                                                                  required,
                                                                  onChange,
                                                                  disabled,
                                                                  fullWidth = false,
                                                                  className = '',
                                                                  error
                                                              }) => {

    const [name, setName] = useState(value);
    const i18n = useI18nContext();

    useEffect(() => {
        setName(value);
    }, [value]);

    const onNameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newName = event.target.value;
        setName(newName);
        onChange(newName);
    }

    return (
        <TextInput
            error={error}
            label={i18n.translate("LASTNAME") + `${required ? '*' : ''}`}
            value={name}
            placeholder={placeholder}
            disabled={disabled}
            onChange={onNameChange}
            startIcon={PersonIcon}
            className={className}
            fullWidth={fullWidth}
        />
    )
}


export default LastNameInput;